module.exports = __webpack_public_path__ + "static/media/hspa.41682a18.jpg";